// extracted by mini-css-extract-plugin
export default {"section":"TransitTab_section__Rj4VA","title":"TransitTab_title__uJhXB"};